/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useMemo } from 'react';
import { useProjectSettingsSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-settings-connect-addons/index.tsx';
import { transformLinkV4 } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-connect/src/common/utils/transform-link/index.tsx';
import type { ConnectDataItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-connect/src/common/types.tsx';
import { LEGACY_CONNECT_ITEM_IDS } from './constants.tsx';

export const useConnectApps = (): {
	data: ConnectDataItem[];
	loading: boolean;
	error: // oxlint-disable-next-line @typescript-eslint/no-explicit-any
		| Record<string, any>
		| Error // oxlint-disable-next-line @typescript-eslint/no-explicit-any
		| (Record<string, any> & Error) // oxlint-disable-next-line @typescript-eslint/no-explicit-any
		| (Error & Record<string, any>)
		| null;
} => {
	const {
		data: connectResourceItems,
		error,
		loading,
	} = useProjectSettingsSidebarConnectAddonsNavigationResource();

	const connectApps = useMemo(() => {
		if (connectResourceItems == null) {
			return [];
		}

		const transformedConnectApps = [];

		for (const item of connectResourceItems) {
			const transformedItem = transformLinkV4(item);

			if (transformedItem && !LEGACY_CONNECT_ITEM_IDS.has(transformedItem.id)) {
				transformedConnectApps.push(transformedItem);
			}
		}

		return transformedConnectApps;
	}, [connectResourceItems]);

	return {
		data: connectApps,
		loading,
		error,
	};
};
